<div class="flex flex-col gap-1 px-2" *hasScope="SCOPES.UNDELIVERED_REASONS.READ_ALL">
  <!-- Toast Notification Message -->
  @if (showSuccessMessage()) {
    <div
      class="fixed top-5 right-5 z-50 flex items-center gap-2 rounded-lg bg-green-600 px-4 py-3 text-white shadow-lg transition-all">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd" />
      </svg>
      <span>{{ successToastMessage() }}</span>
    </div>
  }

  <!-- Header Section (Title & Add Button) -->
  <div class="flex items-center justify-between py-2">
    <h2 class="textTabsColor text-2xl font-bold" i18n="@@undeliveredReasonsTitle">Undelivered Reasons</h2>
    <button
      *hasScope="SCOPES.UNDELIVERED_REASONS.CREATE"
      (click)="onAddReason()"
      class="bgPrimaryColor hover:bgHoverPrimaryColor flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white transition-colors hover:cursor-pointer">
      <app-add-icon />
      <span i18n="@@addUndeliveredReason">Create New Reason</span>
    </button>
  </div>

  <!-- Search Settings Card -->
  <div class="bgWhiteColor mb-2 flex flex-col gap-4 rounded-lg border border-gray-200 p-4 filters-shadow">
    <!-- Reason Search Input -->
    <div class="grid grid-cols-4 gap-4">
      <app-filter-item-search
        [label]="searchLabel()"
        [placeholder]="searchPlaceholder()"
        [(searchTerm)]="reasonFilter" />
    </div>

    <!-- Date Filters Row (4 fields) -->
    <div class="grid grid-cols-4 gap-4">
      <app-filter-date-component
        [label]="createdOnFromLabel()"
        [(value)]="createdOnFrom"
        [isInvalid]="isCreatedDateRangeInvalid()" />

      <app-filter-date-component
        [label]="createdOnToLabel()"
        [(value)]="createdOnTo"
        [isInvalid]="isCreatedDateRangeInvalid()" />

      <app-filter-date-component
        [label]="modifiedOnFromLabel()"
        [(value)]="modifiedOnFrom"
        [isInvalid]="isModifiedDateRangeInvalid()" />

      <app-filter-date-component
        [label]="modifiedOnToLabel()"
        [(value)]="modifiedOnTo"
        [isInvalid]="isModifiedDateRangeInvalid()" />
    </div>

    <!-- Sort + Actions Row -->
    <div class="my-5 flex items-end justify-between border-t border-gray-200 pt-4">
      <app-filter-sorting-component
        [(orderBy)]="orderBy"
        [orderDir]="orderDir()"
        [sortOptions]="sortOptions()"
        (toggleOrder)="toggleSortOrder()" />

      <div class="flex items-end gap-3">
        <button
          (click)="resetFilters()"
          class="borderPrimaryColor textPrimaryColor hover-bg-primary-10 rounded-md border px-5 py-1.5 text-sm font-medium hover:cursor-pointer">
          <span i18n="@@adminProductsResetButton">Clear</span>
        </button>
        <button
          (click)="applyFilters()"
          class="bgPrimaryColor hover:bgHoverPrimaryColor rounded-md px-5 py-1.5 text-sm font-medium text-white hover:cursor-pointer">
          <span i18n="@@adminCategoriesSubmitButton">Apply</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content State -->
  @if (loading()) {
    <div class="bgWhiteColor mt-2 flex items-center justify-center rounded-lg border border-gray-200 py-12 shadow-sm">
      <app-loading />
    </div>
  } @else if (errorGettingReasons()) {
    <div class="mt-2">
      <app-error-data [title]="errorGettingReasons()!" [showRetry]="true" (retry)="loadReasons()" />
    </div>
  } @else {
    <!-- Table Section -->
    <app-tables
      [headerItems]="headerItems()"
      [rows]="tableRows()"
      [selectable]="false"
      [currentActions]="currentActions()"
      [isFiltersApplied]="isFiltersApplied()"
      [emptyFilterTitle]="emptyFilterTitle()"
      [emptyContentTitle]="emptyContentTitle()"
      [emptyContentDescription]="emptyContentDescription()"
      (toggleDropdown)="toggleDropdown($event)"
      (actionSelected)="onTableAction($event)"
      (actionTrigger)="onHandleAction($any($event))"></app-tables>
  }

  <!-- Pagination Component -->
  @if (!loading() && !errorGettingReasons() && reasons().length > 0) {
    <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="getPageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="previousPage()"
      (nextPage)="nextPage()"
      (goToPage)="goToPage($event)"
      (changePageNumber)="onPageSizeChange($event)"
      (pageSizeChange)="applyFilters()"></app-pagination>
  }

  <!-- Delete Confirmation Modal Component -->
  @if (showDeleteDialog() && reasonToDelete()) {
    <app-undelivered-reasons-delete-component
      [reason]="reasonToDelete()!"
      (onClose)="closeDeleteDialog()"
      (onSuccess)="onDeleteSuccess($event)" />
  }
</div>
